import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-97f3d4e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "screen-wrapper" }
const _hoisted_2 = { class: "p-4" }
const _hoisted_3 = { class: "info-wrapper mb-6 px-4 pb-4" }
const _hoisted_4 = { class: "field" }
const _hoisted_5 = { class: "name mt-4" }
const _hoisted_6 = { class: "field" }
const _hoisted_7 = { class: "name mt-4" }
const _hoisted_8 = { class: "field" }
const _hoisted_9 = { class: "name mt-4" }
const _hoisted_10 = { class: "field" }
const _hoisted_11 = { class: "name mt-4" }
const _hoisted_12 = {
  key: 0,
  class: "field"
}
const _hoisted_13 = { class: "name mt-4" }
const _hoisted_14 = { class: "buttons larger-action-button mt-6" }

import { useRoute, useRouter } from 'vue-router'
import { computed, onMounted, ref } from 'vue'
import { hexToNumberString } from 'web3-utils'

import IconButton from '@/popup/components/shared/IconButton.vue'
import Button from '@/popup/components/shared/Button.vue'
import { GlobalDatabase, PopupDatabase } from '@/popup/storage/Database'
import ApprovalHeader from '@/popup/components/shared/ApprovalHeader.vue'
import Notification from '@/popup/components/shared/Notification.vue'
import { NetworkInfoDBSchema } from '@/shared/Database/UPSettings/models'
import Sanitize from '@/popup/components/shared/Sanitize.vue'
import { useGlobals } from '@/popup/compositions/useGlobals'
import { useApprovalsStore } from '@/popup/store/ApprovalsStore'
import { redirectAfterApproval } from '@/popup/utils/redirectAfterApproval'
import { useAppStore } from '@/popup/store/AppStore'
import { removeSchemaFromUrl, truncateMiddle } from '@/shared/utils'
import { InternalMethods } from '@/shared/apis/messages'


export default /*#__PURE__*/_defineComponent({
  __name: 'SwitchNetwork',
  setup(__props) {

const network = ref({
  name: '',
  http: { url: '' },
  ws: { url: '' },
  explorer: { url: '' },
  chainId: '',
} as NetworkInfoDBSchema)
const chainId = ref<string>('')
const router = useRouter()
const route = useRoute()
const appStore = useAppStore()
const switchId = route.params.switchId as string | undefined
const approvalsStore = useApprovalsStore()
const icon = ref<string>('')
const approval = switchId ? approvalsStore.getApproval(switchId) : undefined

const selectedNetwork = computed(() => appStore.network)

onMounted(async () => {
  if (switchId && approval?.requestData) {
    const dbOrigin = await PopupDatabase.getOrigin(encodeURI(approval?.origin))
    icon.value = dbOrigin?.icon as string
    const dbNetwork = await GlobalDatabase.getNetworkByChainId(
      (approval?.requestData as { chainId: string }).chainId
    )
    if (dbNetwork) {
      network.value = dbNetwork
      chainId.value = hexToNumberString(dbNetwork.chainId)
    }
  }
})

const approveSwitch = async () => {
  if (network.value.id === selectedNetwork.value.id) {
    return
  }
  try {
    const selectedProfile = await appStore.switchToNetwork(
      network.value.id,
      approval?.id
    )
    if (approval?.id) {
      approvalsStore.deleteApproval(approval.id)
    }
    if (selectedProfile) {
      router.push('/')
    } else if (appStore.network.id.startsWith('base')) {
      router.push({
        path: '/add-base-account',
      })
    } else {
      router.push({
        path: '/add-account',
        query: {
          from: 'settings',
        },
      })
    }
  } catch {
    await appStore.switchToPreviousNetwork()
  }
}

const onCancel = async () => {
  if (approval?.id) {
    useGlobals().sendMessage({
      method: InternalMethods.SWITCH_NETWORK,
      payload: { networkId: '', approvalId: approval.id },
    })
    approvalsStore.deleteApproval(approval.id)
  }
  redirectAfterApproval(
    router,
    approvalsStore.nonStashedApprovals.length,
    appStore.lastPopupState?.path
  )
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ApprovalHeader, { icon: icon.value }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('modal.network_switch.switch_network')), 1 /* TEXT */)
      ]),
      subtitle: _withCtx(() => [
        _createVNode(Sanitize, {
          html: _unref(truncateMiddle)(_unref(removeSchemaFromUrl)(_unref(approval)?.origin), 25)
        }, null, 8 /* PROPS */, ["html"])
      ]),
      actions: _withCtx(() => [
        _createVNode(IconButton, {
          tooltip: _ctx.$t('sign.cancel'),
          onOnClick: _cache[0] || (_cache[0] = ($event: any) => (onCancel()))
        }, null, 8 /* PROPS */, ["tooltip"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["icon"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('network.add.name_label')), 1 /* TEXT */),
          _createVNode(Sanitize, {
            html: network.value.name
          }, null, 8 /* PROPS */, ["html"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('network.add.rpc_url_label')), 1 /* TEXT */),
          _createVNode(Sanitize, {
            html: network.value.http.url
          }, null, 8 /* PROPS */, ["html"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('network.add.websocket_url_label')), 1 /* TEXT */),
          _createVNode(Sanitize, {
            html: network.value.ws.url
          }, null, 8 /* PROPS */, ["html"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('settings.network.title')), 1 /* TEXT */),
          _createTextVNode(" " + _toDisplayString(chainId.value), 1 /* TEXT */)
        ]),
        (network.value.explorer?.url)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('network.add.explorer_url_label')), 1 /* TEXT */),
              _createVNode(Sanitize, {
                html: network.value.explorer?.url
              }, null, 8 /* PROPS */, ["html"])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _createVNode(Notification, { class: "mb-4" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('network.switch.warning')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(Button, {
          variant: "text",
          type: "button",
          onClick: onCancel
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('qr_code.import_profile.cancel')), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(Button, {
          variant: "primary",
          "is-full-width": true,
          type: "submit",
          disabled: !network.value.chainId,
          "data-testid": "switch-network-button",
          onClick: approveSwitch
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('modal.network_switch.switch_network')), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["disabled"])
      ])
    ])
  ]))
}
}

})